module.exports = new __parcel__URL__("super-mario-odyssey.27494f11.jpg").toString();